<router-outlet></router-outlet>
<app-qr-scanner-button></app-qr-scanner-button>
